/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Suresh Peddavoora 10/31/2022 3075154998  Changed class name for Text Fields
Raghu Arun Kumar 11/2/2022 3075154998  Responsive Alignment Fixes
Lalitha  11/9/2022  3075154998 Rename Button Clear to Reset
Prakash Gummala 11/10/2022 3075154998 Text Field Alignments for Desktop Resolution
*/
import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import DMSearchTable from './DMSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getObject} from '../../../../../util/GetDropdownObject';
import {getDropDownData} from '../../../../../redux/reducers/EnableFramework/Filter';

import * as Yup from 'yup';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const SearchDMRecordGroup = ({setValue, setFilterCode}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const {filterData} = useSelector(({filter}) => filter);

  const {dropDownData} = useSelector(({filter}) => filter);
  const [submit, setSubmit] = useState(false);
  // const [searchData, setSearchData] = useState([]);
  const searchData = [];
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);

  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });

  const initialValues = {
    code: '',
    recordType:
      filterData && filterData?.type ? getObject(filterData.type, RECORD_TYPE, dropDownData) : '',
    description: '',
    recordIdStart: '',
    recordIdLength: '',
  };

  const handleSubmit = (data) => {
    setSubmit(true);
    searchData(data);
  };

  return (
    <>
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              touched,
              errors,
              values,
              setFieldValue,
              handleChange,
              handleBlur,
              handleReset,
            } = props;
            return (
              <div className="standard-field-textfields">
                <Form autoComplete="off" noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={3} md={4} sm={6} lg={3} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        placeholder={`Enter Code`}
                        label="Code"
                        name="code"
                        value={values?.code?.toUpperCase()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText>{touched.code && errors.code && errors.code} </FormHelperText>
                    </Grid>
                    <Grid item xs={3} md={4} sm={6} lg={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        name="description"
                        placeholder={`Enter Description`}
                        label="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} md={4} lg={3} sm={6} className="pl-md-1 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="recordType"
                        id="recordType"
                        size="small"
                        value={values.recordType}
                        options={getOptions(RECORD_TYPE, dropDownData)}
                        getOptionDisabled={(option) => option.valueCode === null}
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value ?
                            option.valueCode + ' - ' + option.value :
                            option.value === null ?
                              option.valueCode :
                              option.value ?
                                option.value :
                                '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('recordType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              error={touched.recordType && errors.recordType}
                              variant="standard"
                              margin="dense"

                              label="Record Type"
                              placeholder="Select Record Type"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                    <Grid item xs={3} md={12} sm={6} lg={2} className="form-group">
                      <div className="global-buttons">
                        <Button
                          variant="outlined"
                          className={`reset-btn mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            handleReset();
                          }}
                        >
                    Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                    Search
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Form>
              </div>
            );
          }}
        </Formik>
        <Grid>
          <DMSearchTable
            submit={submit}
            setSubmit={setSubmit}
            searchData={searchData}
            setValue={setValue}
            setFilterCode={setFilterCode} />
        </Grid>
      </div>
      {/* {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />} */}
    </>
  );
};
export default SearchDMRecordGroup;
